module.exports = __webpack_public_path__ + "static/media/swipe-right-arrow.11f02ac5.svg";